module.exports = __webpack_public_path__ + "static/media/person1.8f2c9217.jpg";